import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCancel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "cancel",
	"data-name": "cancel",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 4.8476877,
			y1: 19.152311,
			x2: 19.152311,
			y2: 4.8476877,
			id: "line1"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 4.8476877,
			y1: 4.8476877,
			x2: 19.152311,
			y2: 19.152311,
			id: "line2"
		})
	]
});
const ForwardRef = forwardRef(SvgCancel);
export default ForwardRef;
